import Router from 'vue-router';
import Layout from '@/components/Layout.vue';
import Landing from '@/components/landing-pages/Landing.vue';
import DevLayoutIcons from '@/components/DevLayoutIcons.vue';

export const VoxRoutes = [
  {
    path: '/docs',
    name: 'StartPage',
    component: Landing,
  },
  {
    path: '/docs/search',
    name: 'Search',
    meta: {
      fqdn: 'search',
    },
    component: Layout,
  },
  {
    path: '/docs/dev/icons',
    name: 'DEV Icon Page',
    component: DevLayoutIcons,
  },
];

export function createRouter() {
  return new Router({
    linkActiveClass: 'open active',
    mode: 'history',
    routes: VoxRoutes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });
}
